import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../utils/propUtils';
import VeltCommentsSidebarV2Skeleton from './VeltCommentsSidebarV2Skeleton/VeltCommentsSidebarV2Skeleton';
import VeltCommentsSidebarV2Panel from './VeltCommentsSidebarV2Panel/VeltCommentsSidebarV2Panel';
import VeltCommentsSidebarV2Header from './VeltCommentsSidebarV2Header/VeltCommentsSidebarV2Header';
import VeltCommentsSidebarV2CloseButton from './VeltCommentsSidebarV2CloseButton/VeltCommentsSidebarV2CloseButton';
import VeltCommentsSidebarV2EmptyPlaceholder from './VeltCommentsSidebarV2EmptyPlaceholder/VeltCommentsSidebarV2EmptyPlaceholder';
import VeltCommentsSidebarV2List from './VeltCommentsSidebarV2List/VeltCommentsSidebarV2List';
import VeltCommentsSidebarV2PageModeComposer from './VeltCommentsSidebarV2PageModeComposer/VeltCommentsSidebarV2PageModeComposer';
import VeltCommentsSidebarV2FocusedThread from './VeltCommentsSidebarV2FocusedThread/VeltCommentsSidebarV2FocusedThread';
import VeltCommentsSidebarV2MinimalActionsDropdown from './VeltCommentsSidebarV2MinimalActionsDropdown/VeltCommentsSidebarV2MinimalActionsDropdown';
import VeltCommentsSidebarV2FilterDropdown from './VeltCommentsSidebarV2FilterDropdown/VeltCommentsSidebarV2FilterDropdown';
var VeltCommentsSidebarV2Wireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-v2-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarV2Wireframe.Skeleton = VeltCommentsSidebarV2Skeleton;
VeltCommentsSidebarV2Wireframe.Panel = VeltCommentsSidebarV2Panel;
VeltCommentsSidebarV2Wireframe.Header = VeltCommentsSidebarV2Header;
VeltCommentsSidebarV2Wireframe.CloseButton = VeltCommentsSidebarV2CloseButton;
VeltCommentsSidebarV2Wireframe.EmptyPlaceholder = VeltCommentsSidebarV2EmptyPlaceholder;
VeltCommentsSidebarV2Wireframe.List = VeltCommentsSidebarV2List;
VeltCommentsSidebarV2Wireframe.PageModeComposer = VeltCommentsSidebarV2PageModeComposer;
VeltCommentsSidebarV2Wireframe.FocusedThread = VeltCommentsSidebarV2FocusedThread;
VeltCommentsSidebarV2Wireframe.MinimalActionsDropdown = VeltCommentsSidebarV2MinimalActionsDropdown;
VeltCommentsSidebarV2Wireframe.FilterDropdown = VeltCommentsSidebarV2FilterDropdown;
export default VeltCommentsSidebarV2Wireframe;
